import { render, staticRenderFns } from "./DocumentToValidateDetailPage.vue?vue&type=template&id=65413bb2&scoped=true&"
import script from "./DocumentToValidateDetailPage.vue?vue&type=script&lang=js&"
export * from "./DocumentToValidateDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentToValidateDetailPage.vue?vue&type=style&index=0&id=65413bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65413bb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65413bb2')) {
      api.createRecord('65413bb2', component.options)
    } else {
      api.reload('65413bb2', component.options)
    }
    module.hot.accept("./DocumentToValidateDetailPage.vue?vue&type=template&id=65413bb2&scoped=true&", function () {
      api.rerender('65413bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/DocumentToValidateDetailPage.vue"
export default component.exports